import React from "react";
import { useDrop } from "react-dnd";
import FighterCard from "./FighterCard";

export default function MatchCard({ match, onMoveFighter }) {
  const fighters = match.fighters || [];

  const [, drop] = useDrop({
    accept: "FIGHTER",
    drop: (item) => {
      // Prevent dropping if already 2 fighters
      if (fighters.length >= 2) return;

      onMoveFighter?.(item.fromMatchId, match.id, item.fighter);
    },
  });

  return (
    <div ref={drop} className="match-card">
      {fighters.map((fighter) => (
        <FighterCard
          key={fighter.id}
          fighter={fighter}
          matchId={match.id}
        />
      ))}
    </div>
  );
}
